/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DebitMastercardServiceRoleProperties
 */
export interface DebitMastercardServiceRoleProperties {
    /**
     * 
     * @type {string}
     * @memberof DebitMastercardServiceRoleProperties
     */
    propertiesType: string;
}

/**
 * Check if a given object implements the DebitMastercardServiceRoleProperties interface.
 */
export function instanceOfDebitMastercardServiceRoleProperties(value: object): value is DebitMastercardServiceRoleProperties {
    if (!('propertiesType' in value) || value['propertiesType'] === undefined) return false;
    return true;
}

export function DebitMastercardServiceRolePropertiesFromJSON(json: any): DebitMastercardServiceRoleProperties {
    return DebitMastercardServiceRolePropertiesFromJSONTyped(json, false);
}

export function DebitMastercardServiceRolePropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DebitMastercardServiceRoleProperties {
    if (json == null) {
        return json;
    }
    return {
        
        'propertiesType': json['propertiesType'],
    };
}

export function DebitMastercardServiceRolePropertiesToJSON(json: any): DebitMastercardServiceRoleProperties {
    return DebitMastercardServiceRolePropertiesToJSONTyped(json, false);
}

export function DebitMastercardServiceRolePropertiesToJSONTyped(value?: DebitMastercardServiceRoleProperties | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertiesType': value['propertiesType'],
    };
}

